import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { CREATE_MANUAL_JOB_TITLE, ZERO_SHARE_WORKS_JOB_TYPE } from "../../Consts";
import { STATUS_STATE_KEY } from "../../../repertoire/Consts";
import { WORK_STATUS_LOOKUP } from "../../../lookup/Consts";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import DropdownDataInput from "../../../repertoire/components/dropdownDataInput/DropdownDataInput";

export interface IZeroShareWorksParametersProps {
    triggerManualJob: (manualJob: ITriggerManualJob) => any;
    createNewJob: () => any;
    setManualJobParameters: (parameters: ITriggerManualJob) => void;
    lookupValues: ILookupDictionary;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (error: any) => void;
}

interface IZeroShareWorksParametersState {
    selectedWorkStatusCode: string;
    excludedWorkStatusCodes: string[];
    generalError: string;
    isSubmitting: boolean;
}

export class ZeroShareWorksParameters extends React.Component<
    IZeroShareWorksParametersProps,
    IZeroShareWorksParametersState
> {
    state: IZeroShareWorksParametersState = {
        selectedWorkStatusCode: "",
        excludedWorkStatusCodes: [],
        generalError: "",
        isSubmitting: false
    };

    getWorkStatusOptions = () => {
        const { lookupValues } = this.props;
        if (!lookupValues || !lookupValues[WORK_STATUS_LOOKUP]) {
            return [];
        }

        return lookupValues[WORK_STATUS_LOOKUP].lookups.map((item) => ({
            code: item.code,
            description: item.description
        }));
    };

    getExcludedWorkStatusOptions = (): IDropdownOption[] =>
        this.getWorkStatusOptions()
            .map((item) => ({ key: item.code, text: item.description }))
            .sort((a, b) => a.text.localeCompare(b.text));

    handleWorkStatusChange = (value: string | string[] | boolean) => {
        this.setState({ selectedWorkStatusCode: typeof value === "string" ? value : "", generalError: "" });
    };

    handleExcludedWorkStatusChange = (_: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (!option) {
            return;
        }

        this.setState((prevState) => ({
            excludedWorkStatusCodes: option.selected
                ? [...prevState.excludedWorkStatusCodes, option.key as string]
                : prevState.excludedWorkStatusCodes.filter((code) => code !== option.key)
        }));
    };

    renderExcludedWorkStatusTitle = (options?: IDropdownOption[]) => (
        <div>
            <span>{options?.map((o) => o.text).join(", ")}</span>
        </div>
    );

    setParamsAndTriggerJob = () => {
        const { setManualJobParameters, triggerManualJob } = this.props;
        const { selectedWorkStatusCode, excludedWorkStatusCodes } = this.state;

        if (!!selectedWorkStatusCode) {
            const manualJobParameters: ITriggerManualJob = {
                jobType: ZERO_SHARE_WORKS_JOB_TYPE,
                jobParameters: JSON.stringify({
                    workStatusCode: selectedWorkStatusCode,
                    excludedWorkStatusCodes
                })
            };
            setManualJobParameters(manualJobParameters);
            this.setState({ generalError: "" });
            return triggerManualJob(manualJobParameters);
        } else {
            this.setState({ generalError: "Please fill in all the required fields" });
            return false;
        }
    };

    onClick = () => {
        const { onError } = this.props;
        try {
            this.setState({ isSubmitting: true });
            if (this.setParamsAndTriggerJob()) {
                this.props.createNewJob();
                this.props.scheduledJobSet?.(true);
            }
        } catch (err: any) {
            onError?.(err?.toString() || "An error occurred");
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    dismissAlert = () => this.setState({ generalError: "" });

    render() {
        const { selectedWorkStatusCode, excludedWorkStatusCodes, generalError } = this.state;

        return (
            <>
                {generalError && (
                    <div className="alert alert-danger alert-dismissible">
                        <span>{generalError}</span>
                        <button type="button" className="close" aria-label="Close" onClick={this.dismissAlert}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <div className="row">
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <DropdownDataInput
                            label="Work Status"
                            fieldName={STATUS_STATE_KEY}
                            changeData={this.handleWorkStatusChange}
                            value={selectedWorkStatusCode}
                            options={this.getWorkStatusOptions()}
                            allowNull={true}
                            isHidden={false}
                            isMandatory
                        />
                    </div>
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <Dropdown
                            label="Exclude Work Statuses"
                            selectedKeys={excludedWorkStatusCodes}
                            options={this.getExcludedWorkStatusOptions()}
                            multiSelect
                            onChange={this.handleExcludedWorkStatusChange}
                            onRenderTitle={this.renderExcludedWorkStatusTitle}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <ActionButton buttonText={"Cancel"} buttonAction={this.props.createNewJob} className={"button btn-defaultSecondary"} />
                    </div>
                    <div className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                        <ActionButton
                            buttonText={CREATE_MANUAL_JOB_TITLE}
                            buttonAction={this.onClick}
                            disabled={this.state.isSubmitting}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default ZeroShareWorksParameters;
